module.exports = __webpack_public_path__ + "static/media/DreamHack-Hero.122f2b8f.jpg";